module.exports = __webpack_public_path__ + "filedoc-01.png?279fc51a2196739bb2a1ae74a3effdd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filedoc-01.png
// module id = 18
// module chunks = 58